import { render, staticRenderFns } from "./orgSelect.vue?vue&type=template&id=b560c404&scoped=true"
import script from "./orgSelect.vue?vue&type=script&lang=js"
export * from "./orgSelect.vue?vue&type=script&lang=js"
import style0 from "./orgSelect.vue?vue&type=style&index=0&id=b560c404&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b560c404",
  null
  
)

export default component.exports